import { grey } from '@material-ui/core/colors';
import { makeStyles } from '@material-ui/styles';
import React, { useState, useEffect } from 'react';


const DummyCard = ({width, heigth}) => {

    const classes = useStyles()

    return ( 
        <div>
            <div style={{width:width??160, height:heigth?? 101}} className={classes.card}/>
        </div>
     );
}

const useStyles = makeStyles(theme => ({
    card:{
        background:grey[300],
        borderRadius:6,
        margin:'24px 0px'
    }
}))
 
export default DummyCard;